<template>
  <div class="lang_change_cla">
    <slot>
      <el-button-group v-if="!isTextBtn">
        <el-button v-for="item of languages"
                   :key="item.name"
                   :plain="plain"
                   :round="round"
                   :circle="circle"
                   size="mini"
                   type="primary"
                   @click.stop="changeLanguages(item.key)">{{item.name}}</el-button>
      </el-button-group>
      <div v-else>
        <span v-for="item of languages"
              :key="item.name"
              class="text_btn_cla"
              @click.stop="changeLanguages(item.key)">{{item.name}}</span>
      </div>
    </slot>
  </div>
</template>
<script>
import { setCookie } from '../../../utils/index.js'
export default {
  name: 'ZkLangeChange',
  props: {
    plain: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },
    isTextBtn: {
      type: Boolean,
      default: false
    },
    languages: {
      type: Array,
      default: function () {
        return [{
          key: 'zh',
          name: '简体中文'
        }, {
          key: 'en',
          name: '英文'
        }]
      }
    }
  },
  methods: {
    changeLanguages (lan) {
      setCookie('lang', lan)
      window.location.reload()
    }
  }
}
</script>
<style lang="less" scoped>
.lang_change_cla {
  .text_btn_cla {
    cursor: pointer;
  }
  .text_btn_cla:hover {
    color: gray;
  }
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/langChange/src/main.vue